module.exports = {
	"id": "CI",
	"name": "Cote d'Ivoire",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": 0.002555,
			"5": 0.002555,
			"6": 0.002555,
			"7": 0.00511,
			"8": 0.00511,
			"9": 0.022995,
			"10": 0.007665,
			"11": 0.089425,
			"12": 0.043435,
			"13": 0.022995,
			"14": 0.012775,
			"15": 0.00511,
			"16": 0.04088,
			"17": 0.02044,
			"18": 0.01533,
			"19": 0.007665,
			"20": 0.00511,
			"21": 0.01022,
			"22": 0.00511,
			"23": 0.012775,
			"24": 0.002555,
			"25": 0.022995,
			"26": 0.04599,
			"27": 0.048545,
			"28": 0.06643,
			"29": 0.074095,
			"30": 0.084315,
			"31": 0.099645,
			"32": 0.017885,
			"33": 0.07154,
			"34": 0.017885,
			"35": 0.03066,
			"36": 0.03066,
			"37": 0.02044,
			"38": 0.03066,
			"39": 0.03577,
			"40": 0.048545,
			"41": 0.012775,
			"42": 0.02044,
			"43": 0.339815,
			"44": 0.04599,
			"45": 0.05621,
			"46": 0.094535,
			"47": 0.068985,
			"48": 0.063875,
			"49": 2.634205,
			"50": 0.07665,
			"51": 0.30149,
			"52": 0.247835,
			"53": 7.565355,
			"54": 2.32505,
			"55": 0.028105,
			"56": 0.01533,
			"57": null
		},
		"firefox": {
			"2": 0.007665,
			"3": 0.017885,
			"4": 0.00511,
			"5": null,
			"6": null,
			"7": null,
			"8": 0.002555,
			"9": 0.002555,
			"10": 0.00511,
			"11": 0.01022,
			"12": 0.007665,
			"13": 0.002555,
			"14": 0.00511,
			"15": 0.017885,
			"16": 0.01533,
			"17": 0.00511,
			"18": 0.007665,
			"19": 0.01533,
			"20": 0.01022,
			"21": 0.007665,
			"22": 0.007665,
			"23": 0.007665,
			"24": 0.017885,
			"25": 0.007665,
			"26": 0.01022,
			"27": 0.00511,
			"28": 0.00511,
			"29": 0.01533,
			"30": 0.058765,
			"31": 0.043435,
			"32": 0.022995,
			"33": 0.038325,
			"34": 0.02044,
			"35": 0.022995,
			"36": 0.01533,
			"37": 0.028105,
			"38": 0.038325,
			"39": 0.02555,
			"40": 0.048545,
			"41": 0.0511,
			"42": 0.04599,
			"43": 0.34237,
			"44": 0.05621,
			"45": 0.084315,
			"46": 0.08176,
			"47": 0.49056,
			"48": 0.508445,
			"49": 3.145205,
			"50": 0.07665,
			"51": 0.017885,
			"52": null,
			"3.5": null,
			"3.6": 0.007665
		},
		"opera": {
			"9": null,
			"11": null,
			"12": null,
			"15": null,
			"16": 0.00511,
			"17": null,
			"18": null,
			"19": null,
			"20": 0.002555,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.01022,
			"30": null,
			"31": null,
			"32": 0.007665,
			"33": null,
			"34": 0.007665,
			"35": 0.022995,
			"36": 0.0511,
			"37": 0.094535,
			"38": 0.007665,
			"39": 0.03066,
			"40": 0.37303,
			"41": 0.0511,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.002555,
			"12.1": 0.017885
		},
		"safari": {
			"0": null,
			"4": 0.002555,
			"5": 0.012775,
			"6": 0.012775,
			"7": 0.033215,
			"8": 0.048545,
			"9": 0.07154,
			"10": 0.125195,
			"3.1": null,
			"3.2": 0.00511,
			"5.1": 0.012775,
			"6.1": 0.012775,
			"7.1": 0.007665,
			"9.1": 0.14819
		},
		"ios_saf": {
			"8": 0,
			"10": 0.508869608659,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0137134471274,
			"8.1-8.4": 0.0253350124896,
			"9.0-9.2": 0.0120864279767,
			"9.3": 0.184395503747
		},
		"android": {
			"3": 0,
			"4": 0.110679007752,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.013834875969,
			"4.1": 0.399234992248,
			"4.2-4.3": 0.99808748062,
			"4.4": 2.28868376744,
			"4.4.3-4.4.4": 2.30844787597
		},
		"ie": {
			"6": 0.00260209677419,
			"7": 0.00520419354839,
			"8": 0.0832670967742,
			"9": 0.0182146774194,
			"10": 0.0494398387097,
			"11": 0.405927096774,
			"5.5": null
		},
		"op_mob": {
			"0": 3.3553074378,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.0932029843835
		},
		"edge": {
			"12": 0.063875,
			"13": 0.109865,
			"14": 0.140525
		},
		"ie_mob": {
			"10": 0.164397070423,
			"11": 0.669330929577
		},
		"bb": {
			"7": 0.044664,
			"10": null
		},
		"samsung": {
			"0": 1.086824
		},
		"and_uc": {
			"0": 2.181092
		},
		"op_mini": {
			"0": 45.2054735778
		},
		"and_chr": {
			"0": 15.065809
		},
		"and_ff": {
			"0": 0.468972
		}
	},
	"total": 97.733541
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CI.json
 ** module id = 494
 ** module chunks = 0
 **/